import DashboardTemplate from './Dashboard';
export default DashboardTemplate;
